<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <b-row class="mx-0">
        <!-- Transmission live video -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('live_profile')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.main_transmission')"
              label-for="live_profile"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.live_profile"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="availablesOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="live_profile"
                @input="handleInputChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Transmission recorded video -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('recording_profile')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.live_broadcast')"
              :label-for="`recording_profile`"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.recording_profile"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="availablesOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="live_broadcast"
                @input="handleInputChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Configuration transmission -->
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.transmission')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.transmission')"
              :label-for="`transmission`"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.transmission"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="availablesOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="transmission"
                @input="handleTransmissionChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            :name="$t('vxg_camera.video_encoder')"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.video_encoder')"
              label-for="video_encoder"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.video_encoder"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="videoEncoderOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="video_encoder"
                @input="handleCodecChange"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="resolution"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.resolution')"
              label-for="resolution"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.resolution"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="videoResolutionsOptions"
                :clearable="false"
                :reduce="(val) => val.value"
                input-id="resolution"
                @input="handleResolutionChange"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="frame_rate"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera_proxy.frame_rate')"
              label-for="frame_rate"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.frame_rate"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="frameOptions"
                :clearable="false"
                input-id="frame_rate"
                @input="handleInputChange"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="bitrate"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('vxg_camera.bitrate')"
              label-for="bitrate"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="itemData.bitrate"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="BitrateOptions"
                :clearable="false"
                input-id="bitrate"
                @input="handleInputChange"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider :name="$t('vxg_camera.vbr')" rules="required">
            <b-form-checkbox
              id="vbr"
              v-model="itemData.vbr"
              :disabled="!itemData.bitrate_editable"
              name="vbr"
              :value="true"
              :unchecked-value="false"
              class="my-1 text-capitalize"
              switch
              @input="handleInputChange"
            >
              {{ $t("vxg_camera.vbr") }}
            </b-form-checkbox>
          </validation-provider>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
// Resto de las importaciones
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, computed, onMounted } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import store from "@/store";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { forIn } from "lodash";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propResData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propStreamData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemEdit: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();

    const current = computed(() => store.getters["hanwha_camera/getCurrent"]);
    const availables = computed(() => store.getters["hanwha_camera/getAvailables"]);
    const setup = computed(() => store.getters["hanwha_camera/getSetup"]);

    const itemData = ref({
      live_profile: "",
      recording_profile: "",
      transmission: "",
      video_encoder: "",
      resolution: "",
      frame_rate: 0,
      bitrate: 0,
      vbr: false,
      bitrate_editable: false,
    });

    const isDataModified = ref(false);
    const isInitialSetupComplete = ref(false);

    const videoEncoderOptions = ref([]);
    const videoResolutionsOptions = ref([]);
    const frameOptions = ref([]);
    const BitrateOptions = ref([]);

    const validateStep = () => {
      return true;
      //return refFormObserver.value.validate();
    };

    const range = (start, end) => {
      const arr = [];
      for (let i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    };

    const setInitialStreamValues = () => {
      itemData.value.live_profile = current.value.LiveProfile;
      itemData.value.recording_profile = current.value.RecordProfile;
      itemData.value.transmission = availablesOptions[0];
      itemData.value.video_encoder = availables.value[0].format;
      itemData.value.resolution = `${availables.value[0].width}x${availables.value[0].height}`;
      itemData.value.frame_rate = availables.value[0].fps;
      itemData.value.bitrate = availables.value[0].bitrate;
      itemData.value.vbr = availables.value[0].vbr;
      itemData.value.bitrate_editable = availables.value[0].bitrate_editable;

      videoEncoderOptions.value = setup.value.map((setup) => ({
        value: setup.format,
        label: setup.format,
      }));

      let setupSelected = setup.value.find(
        (setup) => setup.format == availables.value[0].format
      );

      videoResolutionsOptions.value = setupSelected.params.map((param) => ({
        value: `${param.width}x${param.height}`,
        label: `${param.width}x${param.height}`,
      }));

      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == availables.value[0].height &&
          param.width == availables.value[0].width
      );

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
    };

    // Call setInitialStreamValues when component mounts
    onMounted(() => {
      if (props.propItemData) {
        setInitialStreamValues();
      }
      handleInputChange()
    });

    const handleInputChange = (field, value,) => {
      emit("update:itemData", itemData.value);
    };

    const handleTransmissionChange = (value) => {
      itemData.value.video_encoder = availables.value[value].format;
      itemData.value.resolution = `${availables.value[value].width}x${availables.value[value].height}`;
      itemData.value.frame_rate = availables.value[value].fps;
      itemData.value.bitrate = availables.value[value].bitrate;
      itemData.value.vbr = availables.value[value].vbr;
      itemData.value.bitrate_editable = availables.value[value].bitrate_editable;
      handleInputChange();
    };

    const handleCodecChange = (value) => {
      let setupSelected = setup.value.find((setup) => setup.format == value);

      videoResolutionsOptions.value = setupSelected.params.map((param) => ({
        value: `${param.width}x${param.height}`,
        label: `${param.width}x${param.height}`,
      }));

      let resolutionSplit = itemData.value.resolution.split('x')

      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == resolutionSplit[0] &&
          param.width == resolutionSplit[1]
      );

      if (!paramsSelected) paramsSelected = setupSelected.params[0]

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
      handleInputChange();
    };

    const handleResolutionChange = (value) => {
      let setupSelected = setup.value.find((setup) => setup.format == itemData.value.video_encoder);

      let resolutionSplit = value.split('x')
      let paramsSelected = setupSelected.params.find(
        (param) =>
          param.height == resolutionSplit[0] &&
          param.width == resolutionSplit[1]
      );

      frameOptions.value = range(1, paramsSelected.max_fps / 1000);

      if (availables.value[0].vbr)
        BitrateOptions.value = range(
          paramsSelected.min_vbr_bitrate,
          paramsSelected.max_vbr_bitrate
        );
      else
        BitrateOptions.value = range(
          paramsSelected.min_cbr_bitrate,
          paramsSelected.max_cbr_bitrate
        );
      handleInputChange();
    };

    let availablesOptions = availables.value.map((available) => ({
      value: available.profile,
      label: available.name,
    }));

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      itemData,
      handleInputChange,

      current,
      availables,
      setup,

      availablesOptions,
      handleTransmissionChange,

      videoEncoderOptions,
      frameOptions,
      BitrateOptions,
      videoResolutionsOptions,

      handleCodecChange,
      handleResolutionChange,
    };
  },
};
</script>
<style scoped>
.mx-0 {
  display: flex;
  align-items: center;
}
</style>
